/*global FB:true*/
/*
* MMF's api for accessing facebook js
* Can be instantiated from any dependency and the module will only init once.
* To access the global FB object, please use the reference attached to this module, ex:
* var mmf_facebook = new MmfFacebook();
* mmf_facebook.FB // to ref window.FB rather than using ref on window
* */
mmf_modules.define('third_party/fb',[
    'facebook',
    'jquery',
    'utils/site',
    'utils/ux',
    'utils/settings'
], function (
    fb_is_global,
    $,
    mmf_site,
    mmf_ux,
    mmf_settings
) {
    'use strict';

    // private context (shared among calling modules)
    var _login_status = null,
        _inited = false,
        _login_deferred;

    var _init = function () {
        _inited = true;
        _login_deferred = new $.Deferred();


        window.fbAsyncInit = function(){
            FB.init({
                appId: mmf_settings.fb.app_id,
                channelUrl: mmf_settings.fb.site_link + '/public/html/channel.html',
                status: true,
                cookie: true,
                xfbml: true,
                version: 'v2.5'
            });

            var responseHandler = function (response) {
                if (response.status === 'connected') {
                    _login_status = true;
                } else {
                    _login_status = false;
                    // the user isn't logged in to Facebook. so hide the facepile
                    $('#facepile').hide();
                }
                _login_deferred.resolve(_login_status, response);
            };

            //on init check if we are logged in or not
            FB.getLoginStatus(responseHandler);

            //if the auth status changes check if we are logged in or not
            FB.Event.subscribe('auth.statusChange', function (response) {
                responseHandler(response);
            });
        };
    };

    var MmfFacebook = function () {
        // init FB ONLY on first call
        if (!_inited) {
            _init();
        }
    };

    // provide a ref to the global FB so this module's export is all you need
    MmfFacebook.prototype.FB = FB;

    // Calls the `callback` with user's logged in status and the resp object
    // The first arg provided to `callback` can be true, false or null
    // The second arg is the fb response object
    MmfFacebook.prototype.getLoginStatus = function (callback) {
        return _login_deferred.done(callback);
    };

    MmfFacebook.prototype.shareViaFeed = function (params) {

        var self = this, temporal_callback;
        params = params || {};

        params.temporalCallback = params.temporalCallback || function (data) {
            var results = {};
            results.fb_text = data.facebook;
            results.fb_image = data.facebook_image;
            self.postToFacebook(results);
        };

        if (params.url) {
            $.ajax({
                url: params.url,
                dataType: 'json',
                success: function (data) {
                    params.temporalCallback(data);
                }
            });
        }
    };


    /**
     * .postToFacebook()
     * A utility function to abstract the Facebook UI API with default values for MMF social sharing.
     *
     * ARGUMENTS
     * [Object] params
     *     An object configuring what and how to share via the _FB.ui API.
     *
     *     PARAMETERS
     *     [Str]  name               -  The title for the share. Defaults to `false` and doesn't show.
     *
     *     [Str]  text               -  The actual text to share on the feed.
     *
     *     [Str]  image              -  An absolute URL to the image to use for this share.
     *                                  Defaults to an MMF icon at:
     *                                  http://dc3d9f49ygq03.cloudfront.net/personal_goals/1399586313509/mmf_share-logo.png
     *
     *     [Str]  link               -  The absolute URL to link back to from the share. Defaults to `window.location.href`
     *
     *     [Bool] show_link_in_text  -  Toggle link auto-appended to the text. Defaults to `true`
     *
     *     [Func] callback           -  Function to call after the share completes, regardless of failure or success.
     *                                  See: https://developers.facebook.com/docs/javascript/reference/FB.ui
     *                                  Defaults to the yellow MMF slide-up banner with a status message depending on success or failure.
     *
     *     DEPRECATED PARAMETERS
     *     These parameters only still exist for legacy implementations that assumed certain values and utilized these verbose keys.
     *     Most notable, and the only one of which I'm personally aware, is personal goals.
     *
     *     [String] fb_text      -  Prefer `text` instead.
     *     [String] fb_image     -  Prefer `image` instead.
     *     [Func]   fb_callback  -  Prefer `callback` instead.
     */
    MmfFacebook.prototype.postToFacebook = function (params) {
        params = params  || {};

        var FB_ui_params = { method: 'feed' },
            name = params.name || false,
            text = params.text || params.fb_text || '',
            image = params.image || params.fb_image || '//dc3d9f49ygq03.cloudfront.net/personal_goals/1399586313509/mmf_share-logo.png',
            callback = params.callback || params.fb_callback || function (response) {
                if (response && response.post_id) {
                    mmf_ux.Messaging.View('Your post has been shared.', 5);
                } else {
                    mmf_ux.Messaging.View('Your post was not shared.', 5);
                }
            },
            link = params.link || 'http://www.' + mmf_site.name + '.com',
            show_link_in_text = params.show_link_in_text || true;

        FB_ui_params.description = text + (show_link_in_text ? ' ' + link : '');
        if (!!image) { FB_ui_params.picture = image; }
        if (!!link) { FB_ui_params.link = link; }
        if (!!name) { FB_ui_params.name = name; }

        FB.ui(FB_ui_params, callback);
    };

    return MmfFacebook;
});

